import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { UserCorporateOptions, UserSecurityOptions } from './';
import { ColorsEnum, Text } from '@shared/widgets';

export const UserOptions = () => {
  const { t } = useTranslation('profile');

  return (
    <div
      className={cn(
        'w-full max-w-80 flex-none',
        'max-[1200px]:max-w-none',
        PaletteUtils.isVcfcPalette && ['rounded-xl dark:border dark:border-gray-black dark:bg-soft-black', 'max-md:w-full'],
      )}
    >
      <div className={cn('bg-white p-6 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-t-xl')}>
        <UserCorporateOptions />
        <UserSecurityOptions />
      </div>
      <div className={cn('bg-white p-6 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-b-xl')}>
        <div className='flex flex-col gap-4 text-center'>
          <Text color={ColorsEnum.Secondary}>{t('restrictions.editLimited')}</Text>
          <Text color={ColorsEnum.Gray}>{t('restrictions.contactAdmin')}</Text>
        </div>
      </div>
    </div>
  );
};
